import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { getAsset } from '../../../../../../../../../util/assets';

const propTypes = {
  className: PropTypes.string,
  discountPercentage: PropTypes.number,
};

const PrintProductDiscountAlert = ({ className, discountPercentage }) => {
  const classes = classNames({
    'print-product-discount-alert': true,
    [className]: !!className,
  });

  return (
    <div className={classes}>
      <img
        src={getAsset('/discount-illustration.svg')}
        alt=""
        className="print-product-discount-alert-icon"
      />

      <div className="print-product-discount-alert-content">
        <p>
          <strong className="text-dark">
            {discountPercentage}% off print products
          </strong>
        </p>
        <p>The discount will be automatically applied during checkout.</p>
      </div>
    </div>
  );
};

PrintProductDiscountAlert.propTypes = propTypes;

export default PrintProductDiscountAlert;
